import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import { createModel, type MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const ROLES = {
    berechnungsgrundlagen_allgemein: 'berechnungsgrundlagen_allgemein',
    berechnungsgrundlagen_gebaeude: 'berechnungsgrundlagen_gebaeude',
    berechnungsgrundlagen_produktion: 'berechnungsgrundlagen_produktion',
    berechnungsgrundlagen_jahreswerte: 'berechnungsgrundlagen_jahreswerte',
    datenimport: 'datenimport',
    berechnungen: 'berechnungen',
    auswertungen: 'auswertungen',
    systemeinstellungen: 'systemeinstellungen',
    bemerkung: 'bemerkung',
};

export class WaermeerzeugerWarmwasser extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    bezeichnung: string | null = null;
    reihenfolge: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'WaermeerzeugerWarmwasser';
    }
}

export async function createNewWaermeerzeugerWarmwasser(): Promise<WaermeerzeugerWarmwasser> {
    const model = createModel(WaermeerzeugerWarmwasser, {});

    await model.save();
    return model;
}

export class WaermeerzeugerWarmwasserCollection extends BaseCollection<WaermeerzeugerWarmwasser> {
    protected modelCls = WaermeerzeugerWarmwasser;

    public getModelClassName(): string {
        return 'WaermeerzeugerWarmwasser';
    }
}